var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicPasswordmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 155,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes asterisk1Animation{0%,10%,to{opacity:0}20%,80%{opacity:1}}@keyframes asterisk2Animation{0%,20%,to{opacity:0}30%,80%{opacity:1}}@keyframes asterisk3Animation{0%,30%,to{opacity:0}40%,80%{opacity:1}}@keyframes asterisk4Animation{0%,40%,to{opacity:0}50%,80%{opacity:1}}@keyframes twinkle{0%,to{transform:scale(.9);opacity:.2}50%{transform:scale(1.1);opacity:1}}@keyframes rotateLock{0%,70%{transform:rotate(0deg)}80%,to{transform:rotate(360deg)}}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5165_11582)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.886 50.891c-.194 0-.386.01-.579.015l.001-.015c0-17.06-13.865-30.891-30.967-30.891-13.888 0-25.641 9.12-29.568 21.685a21.3 21.3 0 0 0-9.922-2.444c-11.78 0-21.329 9.526-21.329 21.277 0 1.914.258 3.767.733 5.532a17.2 17.2 0 0 0-6.995-1.486c-9.532 0-17.26 7.709-17.26 17.218S28.728 99 38.26 99h98.626C150.204 99 161 88.23 161 74.945s-10.796-24.054-24.114-24.054"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5165_11582)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M118.602 70.853c.15 0 .298.007.447.01l-.001-.01c0-13.174 10.696-23.853 23.889-23.853 10.714 0 19.78 7.042 22.81 16.744a16.4 16.4 0 0 1 7.654-1.887c9.087 0 16.453 7.355 16.453 16.429a16.4 16.4 0 0 1-.565 4.271 13.3 13.3 0 0 1 5.396-1.147c7.354 0 13.315 5.953 13.315 13.295 0 7.343-5.961 13.295-13.315 13.295h-76.083C108.328 108 100 99.684 100 89.426s8.328-18.573 18.602-18.573"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "twinkle 2.5s infinite ease-in-out alternate",
      transformOrigin: "115px 70px"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    fillRule: "evenodd",
    d: "M104.158 72.493a.78.78 0 0 1 .635-.786c1.551-.28 5.834-1.293 7.297-2.733s2.452-5.723 2.723-7.297a.77.77 0 0 1 .782-.634v11.45z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M115.543 61.042a.79.79 0 0 1 .773.658c.262 1.541 1.224 5.755 2.673 7.315s5.755 2.466 7.407 2.76a.794.794 0 0 1 .639.787h-11.501z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M115.603 72.494v11.451a.82.82 0 0 1-.782-.658c-.281-1.569-1.293-5.916-2.733-7.36-1.44-1.445-5.728-2.398-7.278-2.66a.78.78 0 0 1-.653-.763z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    fillRule: "evenodd",
    d: "M127.035 72.494a.746.746 0 0 1-.658.769c-1.564.266-5.926 1.223-7.389 2.673s-2.41 5.75-2.673 7.388a.784.784 0 0 1-.773.676V72.5z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "twinkle 3s infinite ease-in-out alternate",
      transformOrigin: "86px 45px"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    fillRule: "evenodd",
    d: "M66.39 55.499a1.366 1.366 0 0 1 1.092-1.362c2.678-.508 10.07-2.225 12.595-4.71s4.232-9.876 4.715-12.594a1.34 1.34 0 0 1 1.356-1.093V55.5z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M86.041 35.74a1.34 1.34 0 0 1 1.326 1.133c.457 2.662 2.114 9.933 4.618 12.625s9.913 4.253 12.778 4.735a1.36 1.36 0 0 1 1.108 1.362H86.056z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M86.148 55.498v19.759a1.42 1.42 0 0 1-1.346-1.133c-.483-2.708-2.23-10.207-4.715-12.702s-9.882-4.135-12.564-4.572a1.35 1.35 0 0 1-1.123-1.321z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    fillRule: "evenodd",
    d: "M105.871 55.498a1.307 1.307 0 0 1-1.138 1.331c-2.693.458-10.223 2.104-12.748 4.609s-4.16 9.922-4.618 12.752a1.346 1.346 0 0 1-1.326 1.163V55.498z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "twinkle 3.5s infinite ease-in-out alternate",
      transformOrigin: "110px 35px"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    fillRule: "evenodd",
    d: "M102.304 34.54a.525.525 0 0 1 .414-.52c1.026-.184 3.846-.846 4.808-1.798s1.614-3.768 1.803-4.808a.514.514 0 0 1 .511-.414v7.54z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M109.802 27.005a.52.52 0 0 1 .511.432c.17 1.017.805 3.791 1.757 4.817.953 1.026 3.791 1.624 4.882 1.813a.524.524 0 0 1 .423.515h-7.573z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M109.84 34.54v7.545a.54.54 0 0 1-.511-.433c-.189-1.035-.851-3.896-1.803-4.858-.953-.961-3.773-1.578-4.794-1.748a.51.51 0 0 1-.428-.506z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    fillRule: "evenodd",
    d: "M117.375 34.54a.5.5 0 0 1-.437.51c-1.026.17-3.902.801-4.868 1.758s-1.587 3.79-1.757 4.867a.52.52 0 0 1-.511.46V34.54z",
    clipRule: "evenodd"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74 101h98v21H74z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0090ED",
    fillRule: "evenodd",
    d: "M62.23 90C56.58 90 52 94.58 52 100.23v22.334c0 5.65 4.58 10.23 10.23 10.23h86.079l19.49 15.296c1.272.998 3.089-.169 2.71-1.741l-3.276-13.591c5.247-.436 9.37-4.833 9.37-10.194V100.23c0-5.65-4.58-10.23-10.23-10.23z",
    clipRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5165_11582)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 101,
    r: 20,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#1CC5A0",
    d: "M69.469 99.582a.516.516 0 0 0-.516-.516H54.515a.516.516 0 0 0-.515.516V109h15.469zM54 110.485a.516.516 0 0 0 .515.515h14.438a.514.514 0 0 0 .516-.515V109H54zm4.533-13.684a3.223 3.223 0 1 1 6.446 0V99.5h2.577v-2.7a5.801 5.801 0 1 0-11.601 0v2.7h2.578z",
    style: {
      animation: "rotateLock 5s infinite ease-out",
      transformOrigin: "62px 102px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m89.855 116.969-.012.209a1.4 1.4 0 1 0 2.796.004l-.012-.214c-.072-1.305 1.363-2.144 2.464-1.439l.303.194a1.383 1.383 0 1 0 1.35-2.406l-.189-.093c-1.18-.576-1.18-2.259 0-2.834l.19-.093a1.382 1.382 0 1 0-1.35-2.406l-.304.194c-1.1.704-2.536-.135-2.464-1.44l.012-.213a1.4 1.4 0 1 0-2.796.003l.012.21c.076 1.303-1.357 2.142-2.457 1.439l-.301-.193a1.383 1.383 0 1 0-1.352 2.407l.188.092c1.179.577 1.179 2.257 0 2.833l-.189.092a1.383 1.383 0 1 0 1.353 2.407l.301-.193c1.1-.703 2.533.137 2.457 1.44",
    style: {
      animation: "asterisk1Animation 5s infinite ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m112.454 116.969-.012.209a1.4 1.4 0 1 0 2.796.004l-.012-.214c-.072-1.305 1.363-2.144 2.464-1.439l.303.194a1.383 1.383 0 1 0 1.351-2.406l-.19-.093c-1.181-.576-1.181-2.259 0-2.834l.19-.093a1.381 1.381 0 1 0-1.351-2.406l-.303.194c-1.101.704-2.536-.135-2.464-1.44l.012-.213a1.4 1.4 0 1 0-2.796.003l.012.21c.076 1.303-1.357 2.142-2.457 1.439l-.301-.193a1.383 1.383 0 1 0-1.352 2.407l.188.092c1.179.577 1.179 2.257 0 2.833l-.189.092a1.383 1.383 0 1 0 1.353 2.407l.301-.193c1.1-.703 2.533.137 2.457 1.44",
    style: {
      animation: "asterisk2Animation 5s infinite ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m134.454 116.969-.012.209a1.4 1.4 0 1 0 2.796.004l-.012-.214c-.072-1.305 1.363-2.144 2.464-1.439l.303.194a1.383 1.383 0 1 0 1.351-2.406l-.19-.093c-1.181-.576-1.181-2.259 0-2.834l.19-.093a1.381 1.381 0 1 0-1.351-2.406l-.303.194c-1.101.704-2.536-.135-2.464-1.44l.012-.213a1.4 1.4 0 1 0-2.796.003l.012.21c.076 1.303-1.357 2.142-2.457 1.439l-.301-.193a1.383 1.383 0 1 0-1.352 2.407l.188.092c1.179.577 1.179 2.257 0 2.833l-.189.092a1.383 1.383 0 1 0 1.353 2.407l.301-.193c1.1-.703 2.533.137 2.457 1.44",
    style: {
      animation: "asterisk3Animation 5s infinite ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m156.454 116.969-.012.209a1.4 1.4 0 1 0 2.796.004l-.012-.214c-.072-1.305 1.363-2.144 2.464-1.439l.303.194a1.383 1.383 0 1 0 1.351-2.406l-.19-.093c-1.181-.576-1.181-2.259 0-2.834l.19-.093a1.381 1.381 0 1 0-1.351-2.406l-.303.194c-1.101.704-2.536-.135-2.464-1.44l.012-.213a1.4 1.4 0 1 0-2.796.003l.012.21c.076 1.303-1.357 2.142-2.457 1.439l-.301-.193a1.383 1.383 0 1 0-1.352 2.407l.188.092c1.179.577 1.179 2.257 0 2.833l-.189.092a1.383 1.383 0 1 0 1.353 2.407l.301-.193c1.1-.703 2.533.137 2.457 1.44",
    style: {
      animation: "asterisk4Animation 5s infinite ease-in-out"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5165_11582",
    width: 204,
    height: 143,
    x: -11,
    y: -14,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_11582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_11582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5165_11582",
    width: 172,
    height: 125,
    x: 68,
    y: 13,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_11582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_11582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5165_11582",
    width: 104,
    height: 104,
    x: 10,
    y: 51,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_11582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_11582",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicPasswordmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_password.min.e706e68d2f0a3cb7433ac02b76e880f8.svg";